import { DateTime } from 'luxon';

export function getTodayDate() {
  const currentTime = DateTime.local().setZone('America/Los_Angeles');
  const todayDate = currentTime.toFormat('MM-dd-yyyy');
  return todayDate;
}
export function getTodayDatePlus30() {
  const currentTime = DateTime.local().setZone('America/Los_Angeles');
  const todayDatePlus30 = currentTime.plus({ days: 30 }).toFormat('MM-dd-yyyy');
  return todayDatePlus30;
}
export function getJan2Date() {
  let currentDate = DateTime.local().setZone('America/Los_Angeles');
  if(!(currentDate.month === 1 && currentDate.day < 2)) {
    currentDate = currentDate.plus({ years: 1 });;
  }
  
  const jan2Date = currentDate.set({ month: 1, day: 2 }).toFormat('MM-dd-yyyy');
  return jan2Date;
}